namespace SolovisGateway.Admin.Organizations {

    export interface OrgAddUserDialogOptions {
        organizationId?: number;

        userAddedCallback?: () => void;
    }

    export class OrgAddUserDialog {

        private _options: OrgAddUserDialogOptions;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;
        private _dialog: Solovis.UI.Dialog;

        constructor(options: OrgAddUserDialogOptions) {
            this._options = options;
        }

        public show() {
            let formBuilderDiv = $("<div>");
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv
            });
            this._formBuilder = formBuilder;

            formBuilder.addEntry({
                name: "fullName",
                label: "Full Name",

                editor: {
                    type: "text",

                    required: true
                }
            });

            formBuilder.addEntry({
                name: "email",
                label: "Email",

                editor: {
                    type: "text",

                    required: true
                }
            });

            formBuilder.addEntry({
                name: "sendInviteEmail",
                label: "Send Invite Email",

                initialValue: true,

                editor: { type: "bool" }
            });

            formBuilder.setupDone();

            this._dialog = formBuilder.showAsDialog({
                title: "Add Organization User",

                desiredWidth: 600,
                desiredHeight: 400,

                showSaveCancel: true,

                saveCallback: () => {
                    if (!formBuilder.hasErrors()) {
                        this._saveAsync();
                    }

                    return false;
                }
            });
        }

        private async _saveAsync(): Promise<void> {
            let fullName = this._formBuilder.getValueByName("fullName");
            let email = this._formBuilder.getValueByName("email");
            let sendInviteEmail = this._formBuilder.getValueByName("sendInviteEmail");

            let response = await Solovis.Rpc.invokeAndWait(
                "~/Organization/AddOrgUser",
                {
                    organizationId: this._options.organizationId,
                    fullName: fullName,
                    email: email,
                    sendInviteEmail: sendInviteEmail
                });

            let modelState = response.result;
            if (modelState) {
                if (modelState.modelIsValid) {
                    this._dialog.close();

                    if (this._options.userAddedCallback) {
                        this._options.userAddedCallback();
                    }
                }
                else {
                    this._formBuilder.applyErrors(modelState.errors);
                }
            }
        }
    }

}
